import {
	Breakpoints,
	Container,
	ContainerGutter,
	ReferenceBadge,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { SilverLabel } from './silver-label';
import { HuchaDisclaimer2Text } from '../../disclaimers/hucha-disclaimers';
import { handleScrollToDisclaimer } from '../../../../../../helpers/disclaimers/disclaimers-utils';
import { useDisclaimers } from '../../../../../../context/disclaimers-context';

const MainContainer = styled(Container)`
	overflow: visible;
	padding: 0px;

	/* Mobile */
	@media (max-width: 959px) {
		padding-top: 40px;
	}

	/* Tablet */
	@media (min-width: 960px) {
		padding-top: 52px;
	}

	/* Desktop */
	@media (min-width: 1280px) {
		padding-top: 24px;
		padding-left: var(--size-dynamic0100);
	}
`;

const StyledC3Wrapper = styled.div`
	border: 2px solid #00b0f0;
	border-radius: 16px;
	position: relative;
	align-content: center;
	padding-left: var(--size-dynamic0130);
	padding-right: var(--size-dynamic0130);

	/* Mobile */
	@media (max-width: 959px) {
		height: 280px;
	}

	/* Tablet */
	@media (min-width: 960px) {
		height: 270px;
	}

	/* Desktop */
	@media (min-width: 1600px) {
		height: 214px;
	}
`;

const StyledTextWrapper = styled(Container)`
	border-top: 2px solid #00b0f0;
	border-bottom: 2px solid #00b0f0;
	padding-top: var(--size-dynamic0050);
	padding-bottom: var(--size-dynamic0050);
	padding-left: 4px;
	padding-right: 4px;

	/* Aseguramos que el wrapper se centre horizontalmente cuando el padre hace wrap='always' */
	margin-left: auto;
	margin-right: auto;

	@media (max-width: 559px) {
		max-width: 227px;
	}

	@media (min-width: 560px) {
		width: 292px;
	}

	@media (min-width: 1600px) {
		/* Cuando wrap='never' podríamos resetear los valores con 'unset' para que dependa del padre */
		margin-left: unset;
		margin-right: unset;
	}
`;

const TextLarge = styled(Text)`
	font-size: 87px;
	line-height: 100%;

	/* Mobile */
	@media (max-width: 559px) {
		font-size: 60px;
	}
`;

const SymbolText = styled(Text)`
	font-size: 44px;
	line-height: 120%;
`;

export const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 15px;

	/* Mobile */
	@media (max-width: 559px) {
		margin-top: 0px;
	}
`;

export const RenovadoresBonusCardC3 = () => {
	const { findBadge } = useDisclaimers();
	const badge = findBadge(HuchaDisclaimer2Text);

	return (
		<MainContainer stretchContent data-testid="c3-container">
			<StyledC3Wrapper>
				<SilverLabel />
				<Container
					gutter={ContainerGutter.dynamic0100}
					verticalAlign="center"
					stretchContent
					horizontalAlign="center"
					data-testid="c3-inner-container"
					wrap={{ [Breakpoints.default]: 'always', [Breakpoints.b1600]: 'never' }}
				>
					<Container wrap="never" horizontalAlign="center">
						<Container wrap="never" verticalAlign="flex-end">
							<TextLarge color={TokenTextColor.inverted}>+1.000</TextLarge>
							<SymbolText color={TokenTextColor.inverted}>{'€'}</SymbolText>
						</Container>
						{badge && (
							<StyledReferenceBadge
								variant="large"
								onClick={() => {
									if (badge) handleScrollToDisclaimer(badge);
								}}
							>
								{badge.replace(/\.$/, '')}
							</StyledReferenceBadge>
						)}
					</Container>

					<StyledTextWrapper stretchContent verticalAlign="center" horizontalAlign="center">
						<Text
							appearance={TokenTextAppearance.headline200}
							color={TokenTextColor.inverted}
							textAlign={TextAlignment.center}
						>
							{'La Excusa Oficial Volkswagen para renovar tu coche este año'}
						</Text>
					</StyledTextWrapper>
				</Container>
			</StyledC3Wrapper>
		</MainContainer>
	);
};
